import { Badge, Clock } from '@chain-zen/ui'

import type { IDateTime } from '../../../../../../types/post'
import { formatDate, formatTo12HourTime } from '../../../../../../utils/datetime-utils'

interface AppointmentDisplayProps {
  appointment: {
    end: IDateTime | null
    isFirstComeFirstServe: boolean
    start: IDateTime | null
  } | null
}

const formatDateTime = (dateTime: IDateTime | null) => {
  if (!dateTime || !dateTime.date) return null

  const formattedDate = dateTime.date ? formatDate(dateTime.date, 'MM/dd/yy') : ''

  let timeToFormat = dateTime.time
  if (timeToFormat && timeToFormat.includes('-')) {
    timeToFormat = timeToFormat.split('-')[1]?.trim()
  }

  const formattedTime = timeToFormat ? formatTo12HourTime(timeToFormat) : ''

  return `${formattedDate}${formattedTime ? `, ${formattedTime}` : ''}`
}

/**
 * Display component for showing appointment times
 */
export const AppointmentDisplay = ({ appointment }: AppointmentDisplayProps) => {
  if (!appointment?.start && !appointment?.end) return null

  return (
    <div className="flex flex-wrap items-center gap-1.5 text-xs">
      {!!appointment.start && (
        <div className="flex items-center gap-1">
          <Clock className="h-3 w-3 text-muted-foreground flex-shrink-0" />
          <span className="text-muted-foreground">Start:</span>
          <span className="truncate">{formatDateTime(appointment.start)}</span>
        </div>
      )}
      {!!appointment.end && (
        <div className="flex items-center gap-1">
          <Clock className="h-3 w-3 text-muted-foreground flex-shrink-0" />
          <span className="text-muted-foreground">End:</span>
          <span className="truncate">{formatDateTime(appointment.end)}</span>
        </div>
      )}
      {!!appointment.isFirstComeFirstServe && (
        <Badge variant="outline" className="text-xs h-5">
          FCFS
        </Badge>
      )}
    </div>
  )
}
